import React from 'react';
import _CopyRight from './_CopyRight.scss'

class CopyRight extends React.Component {

  render() {
    return (
      <div className='copyright-container'>
        <p className="title-social">SÀN THƯƠNG MẠI ĐIỆN TỬ TỈNH PHÚ YÊN</p>
        <p className='footer-description'>Địa chỉ: 78-80 Lê Duẩn, Tp.Tuy Hoà, tỉnh Phú Yên.</p>
        <p className='footer-description'>Điện thoại: (0257).3841.907 - Fax: (0257).3841.585.</p>
        <p className='footer-description'>Email: <a href="mailto:(socongthuong@sctphuyen.gov.vn)">socongthuong@sctphuyen.gov.vn</a></p>
        <p className='footer-description'>Người đại diện: Nguyễn Thanh Tuấn - Giám đốc Sở Công Thương tỉnh Phú Yên</p>
        <p className='footer-description'>Quyết định Hợp nhất Sở Công nghiệp với Sở Thương mại và du lịch thành Sở Công
        Thương số: 484/QĐ-UBND</p>
        <p className='footer-description'>Ngày cấp: 20/03/2008 - Nơi cấp: Ủy Ban Nhân Dân tỉnh Phú Yên</p>
      </div>
    );
  }
}
export default CopyRight;



// WEBPACK FOOTER //
// ./components/layouts/master/sub-footer/CopyRight.jsx